import React, { Component } from 'react';
import { Thumbnail, Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import { } from '../actions'
import { getBlogDescriptionString } from '../utils';

class blogComponent extends Component {

    openBlog(URL) {
        window.open('/blog/' + URL)
    }

    render() {
        const blog = this.props.blog
        return (
            <Thumbnail onClick={() => { this.openBlog(blog.URL) }} style={{ cursor: 'pointer' }} src={blog.thumbnailImage} alt="blogpic" >
                <h3 className='hidden-xs' style={{ cursor: 'pointer' }}>{blog.articleName}</h3>
                <h5 className='hidden-sm hidden-md hidden-lg' style={{ cursor: 'pointer' }}>{blog.articleName}</h5>
                <div style={{ height: 80 }}>
                    <p className='hidden-xs hidden-sm hidden-md' style={{ cursor: 'pointer', color: 'grey', wordWrap: 'break-word' }}>{getBlogDescriptionString(blog.description, 190)}</p>
                    <p className='hidden-xs hidden-sm hidden-lg' style={{ cursor: 'pointer', color: 'grey', wordWrap: 'break-word' }}>{getBlogDescriptionString(blog.description, 120)}</p>
                    <p className='hidden-xs hidden-md hidden-lg' style={{ cursor: 'pointer', color: 'grey', wordWrap: 'break-word' }}>{getBlogDescriptionString(blog.description, 90)}</p>
                    <p className='hidden-sm hidden-md hidden-lg' style={{ cursor: 'pointer', color: 'grey', wordWrap: 'break-word' }}>{getBlogDescriptionString(blog.description, 75)}</p>
                </div>
                <a>
                    อ่านเพิ่มเติม..
                </a>
            </Thumbnail>
        )
    }
}

export default connect(null, {})(blogComponent)


// WEBPACK FOOTER //
// ./src/components/blogComponent.js